import { ExpandIcon as IconExpandIcon } from '@icons/ExpandIcon'
import { Button, styled, Typography } from '@mui/material'

export const Container = styled('div')({
  display: 'grid',
  justifyContent: 'end',
  maxHeight: '100vh',
  overflowY: 'auto',
  pointerEvents: 'auto',
  position: 'fixed',
  right: 0,
  top: 0,
  width: 'auto',
  zIndex: 10000,
})

export const NotificationWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  maxWidth: 450,
  pointerEvents: 'all',
}))

export const ApiMessage = styled(Typography)({
  margin: '6px 0 4px 0',
})

export const ActionButton = styled(Button)({
  marginTop: '0.8rem',
  minWidth: 'unset',
})

export const ApiMessageAction = styled('div')({
  alignItems: 'center',
  display: 'flex',
  marginTop: '-10px',
})

export const ExpandIcon = styled(IconExpandIcon)<{ isRotated: boolean }>(({ isRotated }) => ({
  ...(isRotated
    ? {
        transform: 'rotate(180deg)',
      }
    : {}),
}))
